<template>
  <modal
    :active="active"
    @closed="$emit('closed', true)"
    title="Send faktura på mail"
  >
    <div v-if="!loading">
      <div class="columns is-tablet">
        <form-field class="column" label="Primær email" :error="error.email">
          <input-text
            v-model="form.email"
            :error="error.email"
            @input="error.email = null"
          />
        </form-field>
        <div />
      </div>

      <div class="columns is-tablet">
        <form-field
          class="column"
          label="CC emails (komma separeret liste uden mellemrum)"
          :error="error.cc_emails"
        >
          <input-text
            v-model="form.cc_emails"
            :error="error.cc_emails"
            @input="error.cc_emails = null"
          />
        </form-field>
        <div />
      </div>

      <div class="columns is-tablet">
        <form-field
          class="column"
          label="Opdatér CC emails i kundestamkortet"
          :error="error.email"
        >
          <input-checkbox
            v-model="form.overwrite_customer_details"
            :error="error.overwrite_customer_details"
          />
        </form-field>
        <div />
      </div>
      <span class="general-error" v-if="generalError != null">{{
        generalError
      }}</span>
    </div>
    <Loader v-else />

    <template v-slot:footer class="has-space-between">
      <div class="footer-spacer">
        <div>
          <button class="button is-default" @click="$emit('closed', true)">
            Send ikke faktura
          </button>
          <button class="button is-primary" @click="submit">Send</button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@elems/modal";
import { FormField, InputText, InputCheckbox } from "@elems/form";
import Loader from "@elems/loader";

export default {
  components: {
    Modal,
    Loader,
    FormField,
    InputCheckbox,
    InputText
  },
  props: {
    active: Boolean,
    project: Object,
  },
  data() {
    return {
      form: {
        email: "",
        cc_emails: "",
        overwrite_customer_details: false
      },
      error: [],
      loading: false,
      generalError: null
    };
  },

  watch: {
    active() {
      this.reset();
    },
    project() {
      this.reset();
    }
  },

  methods: {
    async submit() {
      this.loading = true;
      await axios
        .post(`/api/projects/${this.project.id}/sendInvoiceMails`, {
          email: this.form.email,
          cc_emails: this.form.cc_emails,
          overwrite_customer_details: this.form.overwrite_customer_details
        })
        .then(() => {
          this.loading = false;

          this.$emit("closed");
          this.$store.dispatch("setSuccess", "Email(s) blev sendt");
        })
        .catch(error => {
          this.loading = false;

          if (error.response && error.response.status === 422) {
            this.error = error.response.data.errors;
          }
          if (error.response && error.response.status != 422) {
            this.generalError = error.response.data;
          }
        });
    },

    reset() {
      this.form = {
        email: this.project.customer.email,
        cc_emails: this.project.customer.cc_emails,
        overwrite_customer_details: false
      };
      this.error = [];
      this.generalError = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-spacer {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.customer-details {
  h4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #bbb;
    margin-bottom: 25px;
    cursor: pointer;

    i {
      transition: transform 0.3s ease-in-out;
    }
  }

  .column {
    display: none;
  }

  &.open {
    h4 i {
      transform: rotate(0.5turn);
    }

    .column {
      display: block;
    }
  }
}

.general-error {
  color: red;
}

.column {
  padding: 0 0.75rem;
}
</style>
